/* ORA INHALE — Pixel events (Meta + TikTok) */
(function () {
  'use strict';

  var hasMeta   = typeof fbq === 'function';
  var hasTiktok = typeof ttq !== 'undefined';

  if (!hasMeta && !hasTiktok) return;

  // ─── Helpers ────────────────────────────────────────────
  function fireMeta(event, data) {
    if (hasMeta) fbq('track', event, data || {});
  }

  function fireTiktok(event, data) {
    if (hasTiktok) ttq.track(event, data || {});
  }

  function fireAll(metaEvent, tiktokEvent, data) {
    fireMeta(metaEvent, data);
    fireTiktok(tiktokEvent, data);
  }

  // ─── ViewContent (fiche produit) ────────────────────────
  if (window.OraPixelProduct) {
    var p = window.OraPixelProduct;
    fireMeta('ViewContent', {
      content_ids:  [p.id],
      content_name: p.name,
      content_type: 'product',
      value:        p.price,
      currency:     p.currency
    });
    fireTiktok('ViewContent', {
      content_id:   p.id,
      content_name: p.name,
      content_type: 'product',
      value:        p.price,
      currency:     p.currency
    });
  }

  // ─── Purchase (page confirmation commande) ───────────────
  if (window.OraPixelOrder) {
    var o = window.OraPixelOrder;
    var contents = o.items.map(function (i) {
      return { id: i.id, quantity: i.quantity, price: i.price };
    });

    fireMeta('Purchase', {
      value:        o.value,
      currency:     o.currency,
      content_ids:  o.items.map(function (i) { return i.id; }),
      content_type: 'product',
      contents:     contents,
      order_id:     o.id
    });
    fireTiktok('CompletePayment', {
      value:        o.value,
      currency:     o.currency,
      content_id:   o.id,
      contents:     contents
    });
  }

  // ─── AddToCart ───────────────────────────────────────────
  document.addEventListener('cart:updated', function (e) {
    var cart = e.detail;
    if (!cart || !cart.items || !cart.items.length) return;

    var lastItem = cart.items[0];
    var data = {
      content_ids:  [String(lastItem.product_id)],
      content_name: lastItem.product_title,
      content_type: 'product',
      value:        lastItem.final_price / 100,
      currency:     cart.currency
    };

    fireMeta('AddToCart', data);
    fireTiktok('AddToCart', {
      content_id:   String(lastItem.product_id),
      content_name: lastItem.product_title,
      content_type: 'product',
      value:        lastItem.final_price / 100,
      currency:     cart.currency,
      quantity:     lastItem.quantity
    });
  });

  // ─── InitiateCheckout ────────────────────────────────────
  function onInitiateCheckout() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var ids = cart.items.map(function (i) { return String(i.product_id); });
        var data = {
          content_ids:  ids,
          content_type: 'product',
          value:        cart.total_price / 100,
          currency:     cart.currency,
          num_items:    cart.item_count
        };
        fireMeta('InitiateCheckout', data);
        fireTiktok('InitiateCheckout', {
          content_id:   ids[0] || '',
          content_type: 'product',
          value:        cart.total_price / 100,
          currency:     cart.currency,
          quantity:     cart.item_count
        });
      });
  }

  // Intercepter tous les liens / boutons qui déclenchent le checkout
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[href="/checkout"], .ora-cart-checkout-btn, [name="checkout"]');
    if (el) onInitiateCheckout();
  });

})();
